import './HomeComponents.css';

interface HowItWorksProps {
  id?: string;
}

const HowItWorks = ({ id }: HowItWorksProps) => {
  return (
    <section className="how-it-works" id={id}>
      <div className="section-header">
        <h2>How It Works</h2>
        <p>Whether you need help or want to help others, Olitask makes it simple</p>
      </div>

      <div className="how-it-works-split">
        <div className="requester-column">
          <div className="column-header">
            <h2>For Requesters</h2>
            <p>Get things done, your way</p>
          </div>

          <div className="step-card">
            <div className="step-number-badge">1</div>
            <div className="step-content">
              <h3>Post a Task</h3>
              <p>Describe what you need help with, set your budget, and choose a timeframe. It takes less than 2 minutes.</p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-number-badge">2</div>
            <div className="step-content">
              <h3>Receive Offers</h3>
              <p>Get notified when nearby helpers respond. Review their profiles, ratings, and offers.</p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-number-badge">3</div>
            <div className="step-content">
              <h3>Choose & Relax</h3>
              <p>Pick the best helper for the job. Track progress in real-time and pay securely after completion.</p>
            </div>
          </div>

          <div className="highlight-box">
            <p>✨ Requester benefits:</p>
            <ul>
              <li>Verified helpers with reviews</li>
              <li>Secure in-app payments</li>
              <li>Real-time task tracking</li>
              <li>24/7 customer support</li>
            </ul>
            <a href="#" className="cta-mini">Post a task →</a>
          </div>
        </div>

        <div className="helper-column">
          <div className="column-header">
            <h2>For Helpers</h2>
            <p>Earn money on your terms</p>
          </div>

          <div className="step-card">
            <div className="step-number-badge">1</div>
            <div className="step-content">
              <h3>Sign Up & Get Verified</h3>
              <p>Create your helper profile, complete verification, and showcase your skills to stand out.</p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-number-badge">2</div>
            <div className="step-content">
              <h3>Browse Available Tasks</h3>
              <p>Find tasks near you that match your skills and schedule. Choose what works for you.</p>
            </div>
          </div>

          <div className="step-card">
            <div className="step-number-badge">3</div>
            <div className="step-content">
              <h3>Complete & Get Paid</h3>
              <p>Finish the task, receive ratings, and get paid directly to your account. Fast and secure.</p>
            </div>
          </div>

          <div className="highlight-box">
            <p>⚡ Helper advantages:</p>
            <ul>
              <li>Flexible hours - work when you want</li>
              <li>Set your own rates</li>
              <li>Weekly payouts</li>
              <li>Build your reputation with reviews</li>
            </ul>
            <a href="#" className="cta-mini">Become a helper →</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;